var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IframeView',{attrs:{"banner":_vm.banner,"exception":_vm.isContentException,"breadcrumb-items":_vm.breadcrumbItems,"loading":_vm.isContentLoading,"url":_vm.computedUrl},scopedSlots:_vm._u([{key:"iframeSlot",fn:function(){return [(_vm.showFaultPageAlert)?_c('faults-page-alert'):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }